import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllTagsList } from '../../../actions/admin';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import SearchBox from '../../../common/SearchBox';
import { addUserTags, removeUserTags } from '../../../actions/users';
import { debounce, removeDuplicates } from '../../../utils/common';
import LoadingDots from '../../../common/ThreedotLoader';

export default function EditTags({ type = 'ALL', userId }) {
    const { userList } = useSelector((state) => state.partners);
    let findUser = userList && userList.find((user) => user.id === userId);
    const [selectedTags, setSelectedTags] = useState([]);
    const dispatch = useDispatch();
    const isTagsListLoading = useSelector((state) => state.loading.isTagsListLoading);
    const isTagsSearchListLoading = useSelector((state) => state.loading.isTagsSearchListLoading);
    const tagsList = useSelector((state) => state.admin.tagsList);
    const [searchTerm, setSearchTerm] = useState('');

    const toggleTopic = (tag) => {
        let t = selectedTags;
        if (selectedTags.includes(tag.id)) {
            t = selectedTags.filter(t => t !== tag.id);
            dispatch(removeUserTags({ tags: [{ tag_id: tag.id, text: tag.text, icon_url: tag.icon_url }], userId }));
        } else {
            t = [...selectedTags, tag.id];
            dispatch(addUserTags({ tags: [{ tag_id: tag.id, text: tag.text, icon_url: tag.icon_url }], userId }));
        }
        setSelectedTags(t);
    };


    useEffect(() => {
        dispatch(getAllTagsList({ type }));
    }, [dispatch, type]);

    useEffect(() => {

        if (findUser?.tags && Array.isArray(findUser?.tags)) {
            let uids = findUser.tags.map((tag) => tag.tag_id);
            setSelectedTags(uids);
        }

    }, [findUser]);

    const tags = useMemo(() => {
        if (type && tagsList && tagsList[type] && Array.isArray(tagsList[type])) {
            let t = [];
            if (findUser?.tags) {
                t = [...findUser?.tags.filter((u) => u.type === type)]
            }

            let mergeTags = removeDuplicates([...t, ...tagsList[type]], 'id');
            if (searchTerm) {
                return mergeTags.filter(({ text }) =>
                    text.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
            return mergeTags;
        }
        return [];
    }, [tagsList, type, searchTerm, findUser]);

    const searchTags = ({ term, list }) => {
        const find = list.find(({ text }) =>
            text.toLowerCase().includes(term.toLowerCase())
        );
        if (term && !find) {
            // dispatch(getAllTagsList({ query: term, limit: 100, page: 1, appendAtStart: true }));
        }
    };

    const debouncedSearchTerm = useCallback(debounce(searchTags), []);


    const addNewTag = () => {
        if (searchTerm && !tags.includes(searchTerm)) {
            dispatch(addUserTags({
                tags: [{
                    text: searchTerm,
                    type: type
                }],
                userId,
            }));
        }
    };
    if (isTagsListLoading) {
        return <div className='overflow-hidden w-full h-full px-4' ><SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6]} height={20} className='w-full' /></div>
    }


    return <div className="flex flex-col items-center justify-center p-2 pb-4">
        <div className='border-2 rounded-xl mb-2'>
            <SearchBox
                searchTerm={searchTerm}
                onChange={(event) => {
                    setSearchTerm(event.target.value);
                    debouncedSearchTerm({ term: event.target.value, list: tags });
                }}
                placeholder={`Search Tags`}
                onCancel={() => setSearchTerm('')}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') addNewTag(searchTerm)
                }}
            />
        </div>
        <div className="flex flex-wrap justify-center">
            {tags.map((tag) => (
                <button
                    key={tag.id}
                    onClick={() => toggleTopic(tag)}
                    className={`m-2 py-2 px-4 rounded-full text-font10 font-medium transition-colors flex ${selectedTags.includes(tag.id) ? 'bg-tagbg' : 'bg-gray-200 hover:bg-gray-500'
                        }`}
                >
                    <p className='font-medium w-[1rem]'>{selectedTags.includes(tag.id) ? '✓ ' : '+ '}</p> {tag.text}
                </button>
            ))}
        </div>
        {tags.length === 0 && searchTerm && (
            <div className='flex items-center gap-2'>
                {(isTagsSearchListLoading && searchTerm) && <LoadingDots />}
                <button
                    key={''}
                    onClick={() => addNewTag(searchTerm)}
                    className={`m-2 py-2 px-4 rounded-full text-font10 font-medium transition-colors flex bg-tagbg hover:bg-gray-500`}
                >
                    <p className='font-medium w-[1rem]'>+</p> {`Add ${searchTerm}`}
                </button>
            </div>
        )}
    </div >
}